export default __webpack_public_path__ + "assets/gardenkitchenbar.c358de5c.jpg";